import { Scrn, Box, Ln, Bar, Ring, GradBtn, ChipRow, Tick } from "./atoms";

export const CoachGuidedScreen = () => (
    <Scrn title="Guided Workout" badge="Coach Guided">
        <Box className="border-[#3fcbf3]/25 text-center">
            <p className="text-[8px] font-bold uppercase tracking-widest text-[#3fcbf3]">Set 2 of 4</p>
            <p className="mt-0.5 text-[14px] font-extrabold text-white">Goblet Squat</p>
            <p className="text-[9px] text-[#7d8da3]">12 reps · 16 kg</p>
            <div className="mt-2"><Ring pct={0.5} label="0:45" sub="rest" color="#f0356f" /></div>
        </Box>
        <Box>
            <p className="mb-1 text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">Coach says</p>
            <Ln w="w-full" />
            <div className="mt-1"><Ln w="w-3/4" /></div>
        </Box>
        <Box className="flex items-center justify-between">
            <p className="text-[9px] text-[#7d8da3]">Next: Romanian Deadlift</p>
            <span className="text-[8px] font-bold text-[#3fcbf3]">3 of 6 done</span>
        </Box>
        <GradBtn>Complete Set</GradBtn>
    </Scrn>
);

export const ClassicTrackerScreen = () => (
    <Scrn title="Log Workout" badge="Push Day">
        <div className="grid grid-cols-[1fr_auto_auto_auto] gap-1.5 px-1 text-[7px] font-bold uppercase tracking-widest text-[#7d8da3]">
            <span>Exercise</span><span>Set</span><span>Reps</span><span>Kg</span>
        </div>
        {[
            ["Bench Press", "4", "8", "60"],
            ["Incline DB Press", "3", "10", "22"],
            ["Cable Fly", "3", "12", "15"],
            ["Triceps Pushdown", "3", "12", "25"],
        ].map(([n, s, r, k]) => (
            <Box key={n} className="grid grid-cols-[1fr_auto_auto_auto] items-center gap-1.5 !p-2">
                <p className="text-[9px] font-bold text-white">{n}</p>
                {[s, r, k].map((v, i) => (
                    <span key={i} className="rounded border border-white/10 bg-[#0b1422] px-1.5 py-0.5 text-center text-[9px] font-bold text-white">{v}</span>
                ))}
            </Box>
        ))}
        <div className="flex items-center justify-between px-1">
            <span className="text-[8px] text-[#7d8da3]">RPE 8 · Rest 75s</span>
            <span className="text-[8px] font-bold text-[#3fcbf3]">12/12 sets ✓</span>
        </div>
    </Scrn>
);

export const ProgressScreen = () => (
    <Scrn title="Progress" badge="12 Weeks">
        <Box>
            <div className="mb-1 flex items-baseline justify-between">
                <p className="text-[9px] font-bold uppercase tracking-widest text-[#7d8da3]">Body weight</p>
                <p className="text-[10px] font-extrabold text-[#3fcbf3]">−3.2 kg</p>
            </div>
            <svg viewBox="0 0 160 40" className="h-10 w-full">
                <polyline
                    points="0,8 23,10 46,14 69,13 92,19 115,24 138,27 160,31"
                    fill="none" stroke="#3fcbf3" strokeWidth="2" strokeLinecap="round"
                />
            </svg>
        </Box>
        <div className="grid grid-cols-2 gap-2">
            <Box className="text-center"><p className="text-[13px] font-extrabold text-white">92%</p><p className="text-[7px] uppercase tracking-widest text-[#7d8da3]">Nutrition adherence</p></Box>
            <Box className="text-center"><p className="text-[13px] font-extrabold text-white">34</p><p className="text-[7px] uppercase tracking-widest text-[#7d8da3]">Workouts done</p></Box>
        </div>
        <Box>
            <p className="mb-1 text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">Target progress</p>
            <Bar w="68%" c="#f0356f" />
            <p className="mt-1 text-[8px] text-[#7d8da3]">68% to goal · on track</p>
        </Box>
    </Scrn>
);

export const HabitsScreen = () => (
    <Scrn title="Today" badge="Habits">
        <Box className="flex items-center gap-3">
            <Ring pct={0.82} label="8,240" sub="steps" />
            <div className="flex-1">
                <p className="mb-1 text-[8px] font-bold uppercase tracking-widest text-[#7d8da3]">Water · 6 of 8</p>
                <div className="flex gap-1">
                    {Array.from({ length: 8 }).map((_, i) => (
                        <span key={i} className={`h-4 w-2.5 rounded-sm ${i < 6 ? "bg-[#3fcbf3]" : "bg-white/10"}`} />
                    ))}
                </div>
            </div>
        </Box>
        {[
            ["10,000 steps", false],
            ["2.5 L water", false],
            ["7h sleep", true],
            ["Morning mobility", true],
        ].map(([h, done]) => (
            <Box key={h} className="flex items-center justify-between !p-2">
                <p className="text-[9px] font-bold text-white">{h}</p>
                <Tick done={done} />
            </Box>
        ))}
        <p className="text-center text-[8px] font-bold uppercase tracking-widest text-[#3fcbf3]">2 of 4 complete · keep going</p>
    </Scrn>
);

export const RecipesScreen = () => (
    <Scrn title="Recipes" badge="Library">
        <ChipRow items={["High-Protein", "Vegetarian", "Quick", "Breakfast"]} active={0} />
        <Box className="border-[#3fcbf3]/20 !p-0 overflow-hidden">
            <div className="h-9 w-full" style={{ background: "linear-gradient(120deg,#12314a,#3fcbf3/40)" }} />
            <div className="p-2">
                <p className="text-[10px] font-extrabold text-white">Paneer Tikka Bowl</p>
                <p className="text-[8px] text-[#7d8da3]">420 kcal · 32g protein · 15 min</p>
            </div>
        </Box>
        {[
            ["Egg White Oats", "350 kcal · 28g P"],
            ["Chicken Burrito Bowl", "540 kcal · 42g P"],
        ].map(([n, d]) => (
            <Box key={n} className="flex items-center gap-2 !p-2">
                <span className="h-7 w-7 rounded-md" style={{ background: "linear-gradient(135deg,#f0356f/50,#12314a)" }} />
                <div className="flex-1">
                    <p className="text-[9px] font-bold text-white">{n}</p>
                    <p className="text-[8px] text-[#7d8da3]">{d}</p>
                </div>
            </Box>
        ))}
    </Scrn>
);
